//import liraries
import { Dimensions} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize, } from "rn-responsive-styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 372.9,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
      marginHorizontal: 10,
      alignItems: "center",
      flexGrow: 1,
      marginHorizontal: 10,
      overflow: "hidden",
    },
    searchIcon:{
      width: 12.8,
      height: 12.3,
      resizeMode: "contain",
      position: "absolute",
      zIndex: 99,
      right: 10,
      top: 10,
      bottom: 0,
    },
    bgView:{
      height: 1,
      opacity: 0.2,
      backgroundColor: "#25243b",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#707070",
    },
    fastagNbr:{
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.05,
      textAlign: "left",
      color: "#c2c2c2",
    },
    fastagBal:{
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 11,
      letterSpacing: 0,
      textAlign: "left",
      color: "#757575",
    },
    btnRecharge:{
      width: 53,
      height: 15,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },
    btnRechargeText:{
      fontFamily: "Inter",
      fontSize: 7,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 9,
      letterSpacing: 0.14,
      textAlign: "center",
      color: "#bd2d37",
    },
    dropdownStyle: {
      borderWidth: 2,
      borderTopWidth: 1,
      borderColor: "blue",
      minHeight: 50,
      maxHeight: 130,
      position: "absolute",
      zIndex: 9999,
      width: "100%",
      borderBottomRightRadius: 10,
      borderBottomLeftRadius: 10,
      marginTop: 30,
      backgroundColor: "white",
    },
    viewStyle: {
      alignItems: "center",
      flexDirection: "row",
    },
    expenseContainerStyle: {
      alignItems: "center",
    },
    tabViewChartPieStyle: {
      alignItems: "center",
      display: "none",
    },
    chartpieViewStyle: {
      width: 120,
      height: 120,
      alignItems: "center",
      marginTop: 10,
    },
    chartpieTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#a0a0a0",
    },
    chartpieTotalAmtTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#30424e",
    },
    chartpieView: {
      alignItems: "center",
      marginTop: isSmallDevice ? 0 : 0,
      marginBottom: 5,
      display: "flex",
    },
    viewStyle1: {
      height: "100%",
      justifyContent: "center",
      alignItems: "flex-start",
      flexDirection: "row",
      marginTop: 15,
    },
    verticalLineStyle: {
      height: 30,
      width: 5,
      borderRadius: 3,
      backgroundColor: "#837FE1",
    },
    viewStyle2: { width: "100%" },
    viewStyle3: {
      flexDirection: "row",
      alignItems: "center",
      marginTop: 10,
      justifyContent: "center",
      width: "100%",
      display: "flex",
      position: "relative",
      zIndex: 99,
    },
    viewStyle4: { width: "25%" },
    selectedMonthTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#30424e",
    },
    dropdownViewStyle: {
      width: "80%",
      height: 28.6,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#cccccc",
      alignItems: "center",
      alignSelf: "center",
      justifyContent: "center",
      borderRadius: 5,
      marginLeft: 10,
    },
    dropdownContainerStyle: {
      width: "80%",
      height: 70,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#cccccc",
      alignItems: "center",
      alignSelf: "center",
      justifyContent: "center",
      borderRadius: 5,
      marginLeft: 10,
      backgroundColor: "#ffffff",
      position: "absolute",
      zIndex: 9999,
      top: 0,
    },
    dropdownItemViewStyle: {
      borderBottomColor: "#cccccc",
      borderBottomWidth: 1,
      width: "100%",
      alignItems: "center",
    },
    dropdownTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "normal",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#30424e",
      paddingVertical: 5,
    },
    viewStyle5: {
      flexDirection: "row",
      width: "100%",
      paddingHorizontal: 20,
      display: "flex",
    },
    viewStyle6: { flex: 3, paddingHorizontal: 20, marginTop: 5 },
    tagImageStyle: {
      width: 28,
      height: 28,
      paddingLeft: 15,
      alignSelf: "center",
      marginTop: 20,
    },
    input: {
      backgroundColor: "#F1F2F4",
      borderRadius: 10,
      height: 30,
      paddingHorizontal: 20,
    },
    inputContainer: {
      width: 165,
      marginVertical: 5,
    },
    textSmall: {
      fontFamily: "Inter",
      fontSize: 11,
      marginLeft: 5,
      color: "#02122C",
    },
    amoutText: {
      marginLeft: 5,
      fontFamily: "Inter",
      fontSize: 13,
      color: "02122c",
    },
    tagDetails: {
      height: 24,
      minWidth: 70,
      borderWidth: 0,
      borderColor: "#EFF0F2",
      borderRadius: 6,
      marginHorizontal: 5,
      paddingHorizontal: 10,
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "center",
    },
    activeViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      flex: 1,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.36,
      textAlign: "left",
      color: "#30424e",
      paddingTop: 5,
    },
    headerTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0,
      textAlign: "center",
      color: "#9c1d25",
      paddingTop: 10,
    },
    addFavourateViewStyle: {
      display: "flex",
    },
  },

  {
    [DEVICE_SIZES.XL]: {
      container: { maxWidth: 365 },
    },

    [DEVICE_SIZES.LG]: {
      container: { maxWidth: 270 },
    },

    [DEVICE_SIZES.MD]: {
      container: {
        height: 262,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: 0,
        marginVertical: "3%",
        alignItems: "center",
      },

      viewStyle3: {
        width: "60%",
        justifyContent: "flex-start",
      },
      dropdownViewStyle: { width: 69.5 },
      dropdownContainerStyle: { width: 69.5 },

      viewStyle5: { flexDirection: "column" },
      tagImageStyle: {
        width: 22,
        height: 22,
        alignSelf: "flex-start",
      },

      tabViewChartpieStyle: {
        display: "flex",
        alignItems: "center",
        marginRight: 30,
        marginTop: 10,
        backgroundColor: "red",
      },
      chartpieViewStyle: {
        width: 120,
        height: 120,
      },
      chartpieStyle: { display: "none" },
      inputContainer: { width: 165 },

      viewStyle6: { paddingLeft: 0 },
      banner: { display: "none" },
      chartpieView: {
        display: "none",
      },
      tabViewChartPieStyle: {
        display: "flex",
      },
      addFavourateViewStyle: {
        display: "none",
      },
      dropdownStyle: {
        borderColor: "orange",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: "100%",
        height: 227,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginVertical: "3%",
        alignItems: "center",
      },
      chartpieViewStyle: {
        width: 80,
        height: 80,
      },

      viewStyle5: { flexDirection: "column", border: "5px solid grey" },
      viewStyle5: { display: "none" },
      tabViewChartpieStyle: { display: "none" },
      addFavourateViewStyle: {
        display: "none",
      },

    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
        height: 301,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: isTabView ? 0 : 10,
        marginVertical: "3%",
        alignItems: "center",
      },
      chartpieViewStyle: {
        width: 80,
      },
      viewStyle3: {
        // display: "none",
      },

      viewStyle5: {
        display: "none",
      },
      viewStyle1: {
        marginTop: 0,
      },
      addFavourateViewStyle: {
        display: "flex",
      },
      dropdownStyle: {
        borderColor: "orange",
      },
    },
  }
);
//make this component available to the app
export default useStyles;
